export const dateOptions = ['Any', 'Today', 'Past 7 days', 'This month', 'This year'].map(record => ({
  value: record,
  key: record,
  text: record,
}));

export const missingCreditOptions = ['All', 'Yes', 'No'].map(record => ({
  value: record,
  key: record,
  text: record,
}));

export const onlyPhotoOptions = ['All', 'Yes', 'No'].map(record => ({
  value: record,
  key: record,
  text: record,
}));
